<div class="error-box-wrapper">
  <div [@errorBoxState]="state" class="alert alert-danger error-box">
    <strong i18n="@@errors.server-error">Server communication error:</strong> {{error?.userMessage}}
  </div>
</div>
